var map = {
	"./Polygon.webp": 1739,
	"./ada.webp": 3081,
	"./arbitrage-blur.webp": 3156,
	"./arbitrage-icon.webp": 7052,
	"./average-profit.webp": 7851,
	"./balancer.webp": 3197,
	"./binance.webp": 3811,
	"./binance_coion.png": 2650,
	"./bitget.webp": 102,
	"./bitgetTwo.webp": 4288,
	"./bitmart.webp": 5378,
	"./bot-blur.webp": 2902,
	"./bot-icon.webp": 3122,
	"./btc.webp": 8558,
	"./bybit.webp": 2101,
	"./connect-exchange.webp": 31,
	"./curve.webp": 7070,
	"./dashboard-icon.webp": 3421,
	"./dca-blur.webp": 6937,
	"./dca-icon.webp": 8686,
	"./decentralized.webp": 2599,
	"./earnings-icon.webp": 7850,
	"./enzo-logo2.webp": 5341,
	"./eth.webp": 3706,
	"./ethBlue.webp": 9738,
	"./flash-blur.webp": 1875,
	"./flash-icon.webp": 4503,
	"./future-blur.webp": 7218,
	"./future-icon.webp": 8830,
	"./gate.webp": 7804,
	"./history.webp": 6745,
	"./huobi.png": 5746,
	"./indra-icon.webp": 9937,
	"./intra-blur.webp": 4441,
	"./kucoin.webp": 4926,
	"./last-thirty.webp": 9050,
	"./linear-bg-primary.webp": 9421,
	"./logo.webp": 1636,
	"./logo_new.png": 5915,
	"./logo_new.webp": 4289,
	"./logout.webp": 4601,
	"./meta.webp": 8010,
	"./mexc.webp": 8548,
	"./my-subscription-icon.webp": 7197,
	"./okx.webp": 3327,
	"./opportunity-icon.webp": 5758,
	"./phantom.webp": 2764,
	"./plus.webp": 6583,
	"./profit-download.webp": 6676,
	"./profit-icon.webp": 2329,
	"./py.webp": 952,
	"./quickswap.webp": 2117,
	"./referral-code.webp": 1960,
	"./register-img-copy.webp": 1266,
	"./register-img.webp": 7016,
	"./rewards-icon.webp": 7861,
	"./strategies.webp": 8826,
	"./strategy-icon.webp": 8668,
	"./subscription-icon.webp": 4268,
	"./sushiswap.webp": 9712,
	"./swap.webp": 3276,
	"./trade-history.webp": 1170,
	"./triangle-blur.webp": 479,
	"./triangle-icon.webp": 3459,
	"./uniswap.webp": 1992,
	"./wallet.webp": 9602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1225;